export function safeJsonParse<T = unknown>(value?: string | null): T | undefined {
  if (!value) {
    return undefined
  }

  try {
    return JSON.parse(value) as T
  } catch {
    return undefined
  }
}

export function resultJsonParse<T = unknown>(value?: string | null): Result<T | undefined> {
  if (!value) {
    return ok(undefined)
  }

  try {
    return ok(JSON.parse(value) as T)
  } catch (error) {
    return errFromException(error)
  }
}
